<template>
<div class="tgui-barcode img-container center tg-barcode" v-show="realContent">
	<img alt="">
</div>
</template>
<style lang="scss">
.popup-coupon .popup{
	padding-bottom: 0;
	background: transparent;
}
.popup-coupon .popup_content{
	margin: 0;
	padding: 0;
}
.popup-coupon .popup_ok{
	position: absolute;
	top: auto;
	bottom: 26px;
	left: 0;
	right: 0;
	border: 0;
}
</style>
<script>
import $ from 'jquery';
import  "javascript/libs/tg/component/barcode/JsBarcode.all.min.js";
import member from "javascript/libs/tg/api/member.js";
import maple from "maple";

let timer = null;

//function getOpenState(){
//	member.openState({//调用接口
//		success(data){
//			data.state = 1;
//			data.message = '123123';
//			data.url = '123123123';
//			if(data.state==1){
//				if(data.message&&data.url){
//					maple.alert({
//						//title:data.message,
//						content: '<div><img src="//image1.51tiangou.com/tgou2/img2/index/popup-coupon.jpg" width="270" height="350" alt=""></div>',
//						theme: 'popup-coupon',
//						okText: '',
//						okFn(){
//							maple.pageIns.changePage(data.url,{scp:'01.start.alertad.01.dfj02'})
//						}
//					})
//				}
//			}
//			else if(data.state==2){	// 终止请求
//			}
//			else{
////				setTimeout(getOpenState, 1000);
//			}
//		}
//	});
//}
//
//function render(){
//	if(this.realContent){
//		JsBarcode(this.$el.getElementsByTagName('img')[0], this.realContent,{
//			lineColor: this.color,
//			displayValue:this.showText,
//			background:this.background
//		});
//		getOpenState();
//	}
//}
export default {
	ready(){
//		render.call(this)
		this.render();
		/**
		 * 结算码显示后轮训后台接口
		 */
	},
	props:{
		content:{
			type:String,
			default:''
		},
		color:{
			type:String,
			default:'black'
		},
		showText:{
			type:Boolean,
			default:true
		},
		background:{
			type:String,
			default:'transparent'
		}
		, listen: {	// 监听参数，发送 ajax 轮询请求，判断是否扫码
			type: Boolean
			, default: true
		}
	},
	computed:{
		realContent(){
			return this.content.match(/^[\x00-\xFF]+$/)?this.content:''
		}
	},
	methods: {
		render: function(){
			if(this.realContent){
				JsBarcode(this.$el.getElementsByTagName('img')[0], this.realContent,{
					lineColor: this.color,
					displayValue:this.showText,
					background:this.background
				});
				this.listen&&this.getOpenState();
			}
		}
		, getOpenState: function(){
			var that = this
				;

			if( timer ){
				clearTimeout( timer );
				timer = null;
			}

			member.openState({//调用接口
				success(data){
					if( data.state === 1 ){
						if( data.message && data.url ){	// 领取优惠券
//							that.realContent = true;
							that.$dispatch('showCouponPopup');
							maple.alert({
								//title:data.message,
								content: '<div><img src="//image1.51tiangou.com/tgou2/img2/index/coupon-popup.png" width="302" height="352" alt=""></div>',
								theme: 'popup-coupon',
								okText: '',
								okFn(){
									maple.pageIns.changePage(data.url)
								}
							});
						}
						else if( data.couponList && data.couponList.length ){	// 翻转显示优惠券
							that.$dispatch('flipCoupon', data.couponList);
						}
					}
					else if(data.state===2){	// 终止请求
					}
					else{	// 继续发送请求
						if( that.listen ){
//							setTimeout(()=>{
//								that.$dispatch('flipCoupon', [{type: 3, discount: 100.2, name: '1231231230', code: '20440394360591'}, {type: 1, discount: 1.2, name:'123123123', code: '20440394360591'}]);
//							}, 2000)
							timer = setTimeout($.proxy(that.getOpenState, this), 1000);
						}
					}
				}
			});
		}
	},
	watch:{
		content(){
			this.render();
//			render.call(this)
		},
		listen(){
			this.render();
		},
		color(){
			this.render();
//			render.call(this)
		}
	}
};
</script>
